<div class="flex flex-col flex-auto min-w-0 sm:min-h-0 sm:overflow-y-auto">

    <div class="flex flex-row flex-0 items-center justify-between min-h-18 p-4 border-b bg-card dark:bg-transparent">
        <h2 class="text-xl font-bold tracking-tight leading-7 truncate">{{pageTitle}}</h2>
    </div>

    <div class="p-0">
        <div class="max-w-3xl">

            <form [formGroup]="form" class="flex flex-col bg-card overflow-hidden rounded shadow">

                <div class="flex items-start justify-between gap-4 border-b bg-gray-50 p-8 dark:bg-gray-700">
                    <div>
                        <p class="text-lg font-medium">Favourite details</p>
                        <p class="text-secondary">
                            Name this screen and pick an icon for it. Both show up in your favourites list.
                        </p>
                    </div>
                </div>

                <div class="flex flex-col p-8 gap-2">

                    <mat-form-field class="fuse-mat-dense flex-auto">
                        <mat-label>Name</mat-label>
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'mat_outline:bookmark'"></mat-icon>
                        <input matInput formControlName="label" [maxlength]="maxLabelLength"
                            [placeholder]="'Enter a clear name'" required>
                        @if (form.get('label').hasError('required')) {
                        <mat-error>Please provide a name</mat-error>
                        }
                        @if (form.get('label').hasError('maxlength')) {
                        <mat-error>Name cannot exceed {{maxLabelLength}} characters</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field class="fuse-mat-dense flex-auto">
                        <mat-label>Icon</mat-label>
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'mat_outline:palette'"></mat-icon>
                        <mat-select formControlName="icon" required>
                            @for (icon of iconOptions; track icon.value) {
                            <mat-option [value]="icon.value">
                                <div class="flex items-center gap-2">
                                    <mat-icon class="icon-size-5" [svgIcon]="icon.value"></mat-icon>
                                    <span>{{icon.label}}</span>
                                </div>
                            </mat-option>
                            }
                        </mat-select>
                        @if (form.get('icon').hasError('required')) {
                        <mat-error>Please choose an icon</mat-error>
                        }
                    </mat-form-field>

                </div>

                <div class="flex items-center justify-end border-t bg-gray-50 px-8 py-5 dark:bg-gray-700 gap-2">
                    <button type="button" mat-button (click)="dialogRef.close()">
                        Cancel
                    </button>
                    @if (isEditMode) {
                    <button type="button" mat-flat-button [color]="'primary'" (click)="save()">
                        <mat-icon [svgIcon]="'heroicons_outline:check'"></mat-icon>
                        <span class="ml-2 mr-1">Update</span>
                    </button>
                    } @else {
                    <button type="button" mat-flat-button [color]="'primary'" (click)="save()">
                        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                        <span class="ml-2 mr-1">Create</span>
                    </button>
                    }
                </div>

            </form>

        </div>
    </div>
</div>
